import { useI18n } from "vue-i18n";


export const convertToMoney = (number) => {
  return parseInt(number)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

export const translateI18n = (text) => {
  const { t, te } = useI18n();
    return te(text)? t(text) : text ;
};